<template>
  <form @submit.prevent="submit()" >
    <b-row>
      <b-col sm="12" md="4">
          <label for="title" class="form-control-label">{{ $t('views.excmnotificationmessage.form.title') }}:</label>
          <input required :placeholder="$t('views.excmnotificationmessage.form.title')" v-model="item.title" type="text" class="form-control" id="title">
          <div v-if="isInvalid('title')" class="text-danger">
            {{ violations.title }}
          </div>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="description">{{ $t('views.excmnotificationmessage.form.description') }}:</label>
          <input :placeholder="$t('views.excmnotificationmessage.form.description')" v-model="item.description" type="text" class="form-control" id="description" required>
          <div v-if="isInvalid('description')" class="text-danger">
            {{ violations.description }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <label>{{$t("global.type")}}:</label>
        <b-form-group>
          <b-form-checkbox-group v-model="item.messageType" class="" id="massagetype">
            <b-form-checkbox value="1">{{$t("views.exsbmessagesperiodic.form.messageTypes.mail")}}</b-form-checkbox>
            <b-form-checkbox value="2">{{$t("views.exsbmessagesperiodic.form.messageTypes.sms")}}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-show="item.messageType.includes('1')">
        <b-form-group>
          <label for="mailTitle">{{ $t('views.excmnotificationmessage.form.mailTitle') }}:</label>
          <input :placeholder="$t('views.excmnotificationmessage.form.mailTitle')" v-model="item.mailTitle" type="text" class="form-control" id="mailTitle" required>
          <div v-if="isInvalid('mailTitle')" class="text-danger">
            {{ violations.mailTitle }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-show="item.messageType.includes('1')">
        <b-form-group>
          <label for="mailBody">{{ $t('views.excmnotificationmessage.form.mailBody') }}:</label>
          <trumbowyg ref="editor" v-model="item.mailBody" :config="trumbowygConfig" class="form-control" name="htmlContent">
          </trumbowyg>
          <div v-if="isInvalid('mailBody')" class="text-danger">
            {{ violations.mailBody }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-show="item.messageType.includes('2')">
        <label>{{$t("views.exsbmessagesperiodic.form.contentSms")}}:</label>
        <textarea v-model="item.smsBody" name="smsBody" type="text" :placeholder="$t('views.exsbmessagesperiodic.form.contentSms')" class="form-control"></textarea>
      </b-col>
      <b-col sm="12" lg="12">
        <div class="form-group">
          <content-field-legend></content-field-legend>
        </div>
      </b-col>
      <b-col sm="12" lg="12">
        <div class="form-group">
          <custom-field-legend :notificationMessage="item"></custom-field-legend>
        </div>
      </b-col>
      <b-col sm="12" lg="12" v-if="firingThrough === 'case' || firingThrough === 'task'">
        <b-form-group>
          <b-form-checkbox v-model="item.sendAttachments" :value="1" :unchecked-value="0">
            <p class="mt-1" v-if="firingThrough === 'case'">{{$t("views.excmnotificationmessage.form.sendAttachmentsFromCase")}}</p>
            <p class="mt-1" v-if="firingThrough === 'task'">{{$t("views.excmnotificationmessage.form.sendAttachmentsFromTask")}}</p>
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="12" v-if="firingThrough === 'task'">
        <b-form-group>
          <b-form-checkbox v-model="item.sendAttachmentsFromCaseInTask" :value="1" :unchecked-value="0">
            <p class="mt-1">{{$t("views.excmnotificationmessage.form.sendAttachmentsFromCaseInTask")}}</p>
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label for="recipientType">{{ $t('views.excmnotificationmessage.form.recipientType') }}:</label>
          <multi-select @select="onSelectRecipientType" :placeholder="$t('views.excmnotificationmessage.form.recipientType')"
                        :options="recipientTypeCombinedOptions" :selected-options="recipientTypes" id="recipientType"></multi-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <label for="customToUsers">{{ $t('views.excmnotificationmessage.form.customToUsers') }}:</label>
        <input id="customToUsers" v-model="item.customToUsers" class="form-control" placeholder="">
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label for="recipientTypeCc">{{ $t('views.excmnotificationmessage.form.recipientTypeCc') }}:</label>
          <multi-select @select="onSelectRecipientTypeCc" :placeholder="$t('views.excmnotificationmessage.form.recipientTypeCc')"
                        :options="recipientTypeCombinedOptions" :selected-options="recipientTypesCc" id="recipientTypeCc"></multi-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <label for="customCcUsers">{{ $t('views.excmnotificationmessage.form.customCcUsers') }}:</label>
        <input id="customCcUsers" v-model="item.customCcUsers" class="form-control" placeholder="">
      </b-col>
      <b-col sm="12" md="6">
        <label for="customCcUsers">{{ $t('views.excmnotificationmessage.form.customToUsersFromCustomFields') }}:</label>
        <input id="customCcUsers" v-model="item.customToUsersFromCustomFields" class="form-control" placeholder="">
      </b-col>
      <b-col sm="12" md="6">
        <label for="customCcUsers">{{ $t('views.excmnotificationmessage.form.customCcUsersFromCustomFields') }}:</label>
        <input id="customCcUsers" v-model="item.customCcUsersFromCustomFields" class="form-control" placeholder="">
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group>
          <label for="taskType">{{ $t('views.excmcyclictask.form.taskType') }}:</label>
          <model-select :placeholder="$t('views.excmcyclictask.form.taskType')" :options="taskTypeOptions" v-model="item.taskType" id="taskType"></model-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group>
          <label for="caseType">{{ $t('views.excmcyclictask.form.caseType') }}:</label>
          <model-select :placeholder="$t('views.excmcyclictask.form.caseType')" :options="caseTypeOptions" v-model="item.caseType" id="caseType"></model-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group>
          <label for="firingThrough">{{ $t('views.excmnotificationmessage.form.firingThrough.label') }}:</label>
          <model-select :placeholder="$t('views.excmnotificationmessage.form.firingThrough.label')" :options="firingThroughOptions" v-model="item.firingThrough" id="firingThrough"></model-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" v-if="item.firingThrough === 8 || item.firingThrough === 9">
        <b-form-group>
          <label for="firingThrough">{{ $t('views.excmnotificationmessage.form.allowedDocumentTypes') }}:</label>
          <multi-select @select="onSelectDocumentType" :placeholder="$t('views.exsbdocument.form.documentType')" :options="documentTypeOptions" :selected-options="allowedDocumentTypes" id="documentType"></multi-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group>
          <label for="dayAfterStart">{{ $t('views.excmnotificationmessage.form.dayAfterStart') }}:</label>
          <input
            id="dayAfterStart"
            v-model="item.dayAfterStart"
            class="form-control"
            type="number"
            placeholder="">
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" v-if="item.dayAfterStart > 0">
        <b-form-group>
          <label for="repeatAgainCount">{{ $t('views.excmnotificationmessage.form.repeatAgainCount') }}:</label>
          <input
            id="repeatAgainCount"
            v-model="item.repeatAgainCount"
            class="form-control"
            type="number"
            placeholder="">
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" v-if="item.dayAfterStart > 0 && item.repeatAgainCount > 0">
        <b-form-group>
          <label for="repeatAgainInterval">{{ $t('views.excmnotificationmessage.form.repeatAgainInterval') }}:</label>
          <input
            id="repeatAgainInterval"
            v-model="item.repeatAgainInterval"
            class="form-control"
            type="number"
            placeholder="">
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group>
          <label for="senderType">{{ $t('views.excmnotificationmessage.form.senderType') }}:</label>
          <model-select :placeholder="$t('views.excmnotificationmessage.form.senderType')" :options="senderTypeOptions" v-model="item.senderType" id="senderType"></model-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col cols="12">
        <label for="emergencyEmail">{{ $t('views.excmnotificationmessage.form.emergencyEmail') }}:</label>
        <input id="emergencyEmail" v-model="item.emergencyEmail" class="form-control" placeholder="">
      </b-col>
      <b-col cols="12" style="z-index: 0">
        <label for="emergencyText">{{ $t('views.excmnotificationmessage.form.emergencyText') }}:</label>
        <trumbowyg ref="editorEmergencyText" v-model="item.emergencyText" :config="trumbowygConfig" class="form-control" name="emergencyText">
        </trumbowyg>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { ModelSelect, MultiSelect } from 'vue-search-select'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import { mapGetters, mapActions } from 'vuex'
import getId from '@/utils/getIdFromLink'
import ContentFieldLegend from '@/components/Dashboard/Views/excmnotificationmessage/components/contentFieldLegend'
import ApiService from '@/utils/ApiService'
import CustomFieldLegend from '@/components/Dashboard/Views/excmnotificationmessage/components/customFieldLegend.vue'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],
  components: {
    CustomFieldLegend,
    ContentFieldLegend,
    ModelSelect,
    MultiSelect,
    Trumbowyg
  },
  data () {
    return {
      lastSelectItem: {},
      lastSelectItemCc: {},
      recipientTypes: [],
      recipientTypesCc: [],
      senderTypeOptions: [],
      clientTypeOptions: [],
      recipientTypeCombinedOptions: [],
      documentTypeOptions: [],
      allowedDocumentTypes: [],
      firingThroughCaseOptions: [1, 2, 8],
      firingThroughTaskOptions: [3, 4, 5, 6, 7, 9, 10],
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      }
    }
  },
  watch: {
    retrieved (val) {
      if (val) {
        this.getClientTypes()
      }
    }
  },
  computed: {
    firingThrough () {
      if (this.firingThroughCaseOptions.includes(this.item.firingThrough)) {
        return 'case'
      } else if (this.firingThroughTaskOptions.includes(this.item.firingThrough)) {
        return 'task'
      } else {
        return null
      }
    },
    item () {
      return this.initialValues || this.values
    },
    ...mapGetters({
      retrieved: 'excmnotificationmessage/show/retrieved',
      taskTypeOptions: 'excmnotificationmessage/list/taskTypeOptions',
      caseTypeOptions: 'excmnotificationmessage/list/caseTypeOptions',
      firingThroughOptions: 'excmnotificationmessage/list/firingThroughOptions',
      recipientTypeOptions: 'excmnotificationmessage/list/recipientTypeOptions'
    })
  },
  created () {
    this.fetchTaskTypeOptions()
    this.fetchCaseTypeOptions()
    this.fetchSenderTypeOptions()
    this.getClientTypes()
    this.fetchDocumentTypeOptions()
  },
  methods: {
    ...mapActions({
      fetchTaskTypeOptions: 'excmnotificationmessage/list/fetchTaskTypeOptions',
      fetchCaseTypeOptions: 'excmnotificationmessage/list/fetchCaseTypeOptions'
    }),
    submit () {
      if (this.item.dayAfterStart) this.item.dayAfterStart = parseInt(this.item.dayAfterStart)
      else this.item.dayAfterStart = 0
      if (this.item.repeatAgainCount) this.item.repeatAgainCount = parseInt(this.item.repeatAgainCount)
      else this.item.repeatAgainCount = 0
      if (this.item.repeatAgainInterval) this.item.repeatAgainInterval = parseInt(this.item.repeatAgainInterval)
      else this.item.repeatAgainInterval = 0
      this.handleSubmit()
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    initialRecipientTypeHandler () {
      if (this.item.recipientType) {
        this.recipientTypes = this.item.recipientType.map(role => {
          return this.recipientTypeCombinedOptions.find(option => (option.value === parseInt(role) || option.value === role))
        })
      }
    },
    onSelectRecipientType (items, lastSelectItem) {
      this.recipientTypes = items
      this.item.recipientType = items.map(type => getId(type.value))
      this.lastSelectItem = lastSelectItem
    },
    initialRecipientTypeCcHandler () {
      if (this.item.recipientTypeCc) {
        this.recipientTypesCc = this.item.recipientTypeCc.map(role => {
          return this.recipientTypeCombinedOptions.find(option => (option.value === parseInt(role) || option.value === role))
        })
      }
    },
    onSelectRecipientTypeCc (items, lastSelectItem) {
      this.recipientTypesCc = items
      this.item.recipientTypeCc = items.map(type => type.value)
      this.lastSelectItemCc = lastSelectItem
    },
    onSelectDocumentType (items) {
      this.allowedDocumentTypes = items
      this.item.allowedDocumentTypes = items.map(type => getId(type.value))
    },
    initialAllowedDocumentTypesHandler () {
      if (this.item.allowedDocumentTypes) {
        this.allowedDocumentTypes = this.item.allowedDocumentTypes.map(type => {
          return this.documentTypeOptions.find(option => getId(option.value) === type)
        })
      }
    },
    async fetchSenderTypeOptions () {
      let baseParams = { pagination: false }
      const response = await new ApiService('sender_types', baseParams).getResults()
      this.senderTypeOptions = response.items.map(item => {
        return {
          value: item['@id'],
          text: item.title
        }
      })
      this.senderTypeOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    async getClientTypes () {
      let params = { pagination: false, onlyCustomRoles: 1 }
      const response = await new ApiService('client_types', params).getResults()
      this.clientTypeOptions = response.items.map(entry => {
        return {
          value: entry.roles[0],
          text: entry.title + ' (' + this.$t('views.excmnotificationmessage.form.customRole') + ')'
        }
      })
      this.recipientTypeCombinedOptions = JSON.parse(JSON.stringify(this.recipientTypeOptions))
      this.clientTypeOptions.forEach(customRole => {
        this.recipientTypeCombinedOptions.push({ value: customRole.value, text: customRole.text })
      })
      this.initialRecipientTypeHandler()
      this.initialRecipientTypeCcHandler()
    },
    async fetchDocumentTypeOptions () {
      let params = { pagination: false }
      const response = await new ApiService('document_types', params).getResults()
      this.documentTypeOptions = response.items.map(type => {
        return {
          value: getId(type['@id']),
          text: type.title
        }
      })
      this.initialAllowedDocumentTypesHandler()
    }
  }
}
</script>

<style scoped>

</style>
